export const formatDateToShortString = (dateString) => {
  const date = new Date(dateString);
  const shortMonth = date.toLocaleString('en-US', { month: 'short' }).toUpperCase();
  return `${shortMonth} ${date.getDate()} ${date.getFullYear()}`;
};

export const formatTimeFromISO = (isoString: string) => {
  const date = new Date(isoString);
  return date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
};

export const getDurationInMinutes = (startISO: string, endISO: string): number => {
  const diffInMs = new Date(endISO).getTime() - new Date(startISO).getTime();
  return Math.round(diffInMs / 60000);
};

export const groupByMonthYear = (data: any) => {
  const groups = {};

  data.forEach(item => {
    const dateObj = new Date(item.date);

    const monthYear = dateObj.toLocaleDateString('en-US', {
      month: 'long',
      year: 'numeric',
    });

    if (!groups[monthYear]) {
      groups[monthYear] = [];
    }
    groups[monthYear].push(item);
  });

  return Object.entries(groups).map(([date, values]) => ({ date, values }));
};
